<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-10-12 14:26:40
 * @LastEditTime : 2024-03-01 13:09:15
 * @LastEditors  : yangxr
 * @Description  : 自定义报告弹窗
 * @FilePath     : \icps_fb\src\views\platform\ICPS\smart\components_data\customizedReport.vue
-->
<template>
  <!-- 报告选择 -->
  <el-dialog :visible="visible" width="1080px" append-to-body @close="close" @open="searchReport(), (reportParam.rawName = rawName)">
    <span slot="title" class="dialog-title">自定义报告</span>
    <div class="dialogOtherinfo fzyDivFlex">
      <div>
        <el-form ref="form" inline :model="reportParam" label-width="100px">
          <el-form-item label="原物料">
            <el-select v-model="reportParam.rawName" filterable clearable style="width: 100px" placeholder="请选择">
              <el-option v-for="(item, index) in rawArry" :key="index" :label="item.itemName" :value="item.itemName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地">
            <el-input v-model="reportParam.manufarawNamecturer" clearable style="width: 100px"></el-input>
          </el-form-item>
          <el-form-item label="试验日期">
            <el-date-picker v-model="reportParam.sampleTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择日期"> </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="searchReport()">查 询</el-button>
          </el-form-item>
        </el-form>
        <div>
          <el-button size="small" class="bottom_all" style="margin-left: 0" @click="addFromDate()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
        </div>
        <el-table
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          height="500"
          :data="reportData"
          tooltip-effect="dark"
          highlight-current-row
          @row-click="ListChoiceFun"
        >
          <el-table-column width="50" fixed>
            <template slot-scope="scope">
              <el-radio v-model="selectReportId" :disabled="scope.row.disabled" :label="scope.row.id">{{ "" }}</el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="code" label="报告编号" width="100"> </el-table-column>
          <el-table-column prop="createTime" width="150" label="创建时间"> </el-table-column>
          <el-table-column prop="sampleTime" label="试验日期" width="150"> </el-table-column>
          <el-table-column prop="rawNameCombination" label="原物料名称" width="180"> </el-table-column>
          <el-table-column prop="manufacturer" label="厂家" width="100"> </el-table-column>
          <el-table-column prop="originPlace" label="产地" width="80"> </el-table-column>
          <el-table-column prop="company" label="公司" width="180"> </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="reportDelete(scope.row)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="card_bottom">
          <div class="card_bottom_left">
            <div class="top_page_totle">总共{{ reportParam.total }}条</div>
            <el-pagination :current-page.sync="reportParam.page" :page-size="reportParam.pageSize" layout="prev, pager, next, jumper" :total="reportParam.total" @current-change="searchReport()"></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="close">取 消</el-button>
      <el-button class="bottom_all" style="margin-left: 24px" @click="confirmReport()">确 定</el-button>
    </span>
    <!-- 添加 -->
    <el-dialog :visible.sync="addDialog" width="760px" append-to-body :close-on-click-modal="false" :before-close="resetFromDate">
      <span slot="title" class="dialog-title">添加</span>
      <div>
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="fromDate" label-width="110px">
          <div>
            <el-form-item prop="rawManagerId">
              <span slot="label" style="color: #ff0000">原物料</span>
              <el-select ref="raw" v-model="fromDate.rawManagerId" placeholder="请选择" filterable>
                <el-option v-for="(item, index) in rawArry2" :key="index" :label="item.name + '_' + item.specification + '_' + item.brand" :value="item.id" @click.native="selectRaw(item)"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="companyId">
              <span slot="label">公司</span>
              <el-select
                ref="selection1"
                v-model="fromDate.companyId"
                placeholder="请选择"
                filterable
                @change="
                  $nextTick(() => {
                    fromDate.company = $refs.selection1.selectedLabel;
                  })
                "
              >
                <el-option v-for="item in companylist" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <el-form-item prop="sampleTime">
            <span slot="label">试验日期</span>
            <el-date-picker v-model="fromDate.sampleTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期时间"> </el-date-picker>
          </el-form-item>
          <el-form-item>
            <span slot="label">厂家</span>
            <el-input v-model="fromDate.manufacturer" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">产地</span>
            <el-input v-model="fromDate.originPlace" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetFromDate">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="pagessubmitFromDate()">确定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getDicType } from "@/api/common.js";
import { queryPage, queryListByCompany, saveNewReport, deleteReport } from "@/api/smart/components_data/customizedReport.js";
import { permissionsCompanyList } from "@/api/common.js";
import { saveOneRaw, saveResport } from "@/api/smart/produceCoordinate.js";
import { getUserInfo } from "@/utils/auth.js";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rawName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      //导出开盘资料选择报告
      reportData: [],
      reportParam: {
        page: 1,
        pageSize: 10,
        total: 0,
        rawName: "",
        manufarawNamecturer: "",
        sampleTime: "",
      },
      rawArry: [],
      rawArry2: [],
      selectReport: {},
      selectReportId: "",
      companylist: [],
      addDialog: false,
      rules: {
        rawManagerId: [{ required: true, message: "请选择原物料", trigger: "change" }],
        companyId: [{ required: true, message: "请选择公司", trigger: "change" }],
        sampleTime: [{ required: true, message: "请选择试验日期", trigger: "change" }],
      },
      fromDate: {},
      UserInfo: {},
    };
  },
  async mounted() {
    this.UserInfo = await getUserInfo();
    this.companylist = await permissionsCompanyList();
    getDicType({ code: "MATname" }).then(res => {
      this.rawArry = res.data.items;
    });
    queryListByCompany().then(res => {
      this.rawArry2 = res.data;
    });
  },
  methods: {
    confirmReport() {
      let _this = this;
      let json = {
        companyId: this.selectReport.companyId,
        company: this.selectReport.company,
        rawName: this.selectReport.rawName,
        rawId: this.selectReport.rawId,
        brand: this.selectReport.brand,
        dataSourcesId: this.selectReport.id,
        specification: this.selectReport.specification,
        samplingDate: this.selectReport.sampleTime,
        checkoutNumber: this.selectReport.code,
        rawMaterialsId: this.selectReport.rawManagerId,
        manufacturer: this.selectReport.manufacturer,
        originPlace: this.selectReport.originPlace,
        checkoutType: 6,
      };
      saveResport(json).then(res => {
        if (res.code == 1001) {
          if (!res.data) {
            this.$confirm("已存在该编号报告是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              cancelButtonClass: "bottom_all_two",
              confirmButtonClass: "bottom_all",
              type: "warning",
            })
              .then(() => {
                saveOneRaw(json).then(res => {
                  if (res.code == 1001) {
                    _this.$emit("update:visible", false);
                    this.$emit("confirm");
                  }
                });
              })
              .catch(() => {});
          } else {
            _this.$emit("update:visible", false);
            this.$emit("confirm");
          }
        }
      });
    },
    reportDelete(row) {
      this.$confirm("此操作将永久删除该信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          deleteReport({ id: row.id }).then(res => {
            if (res.code == 1001) {
              this.$message.success("删除成功!");
              this.searchReport();
            }
          });
        })
        .catch(() => {});
    },
    selectRaw(item) {
      this.fromDate.rawId = item.rawId;
      this.fromDate.rawName = item.name;
      this.fromDate.brand = item.brand;
      this.fromDate.specification = item.specification;
    },
    pagessubmitFromDate() {
      let _this = this;
      _this.$refs.reffromDate.validate(valid => {
        if (valid) {
          saveNewReport(_this.fromDate).then(res => {
            if (res.code == 1001) {
              _this.$message.success("保存成功!");
              _this.searchReport();
              _this.addDialog = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    searchReport() {
      queryPage(this.reportParam).then(res => {
        if (res.code == 1001) {
          this.reportData = res.data.data;
          this.reportParam.total = res.data.totalRows;
          this.selectReport = "";
          this.selectReportId = "";
        }
      });
    },
    close() {
      this.$emit("update:visible", false);
    },
    //单选选中
    ListChoiceFun(currentRow) {
      if (currentRow) {
        this.selectReport = currentRow;
        this.selectReportId = currentRow.id;
      }
    },
    /*关闭添加弹窗并重置数据*/
    resetFromDate() {
      this.addDialog = false;
    },
    /*添加*/
    addFromDate() {
      this.addDialog = true;
      this.$data.fromDate = this.$options.data().fromDate;
      this.$set(this.fromDate,'companyId',this.UserInfo.companyId || '')
      this.$set(this.fromDate,'company',this.UserInfo.companyName || '')
      console.log(this.fromDate)
      setTimeout(() => {
        this.$refs.reffromDate.clearValidate();
      }, 10);
    },
  },
};
</script>

<style lang="scss" scoped>
.table_link {
  margin-left: 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}
</style>